import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { StripeService } from 'src/app/services/stripe.service';
import { UserService } from 'src/app/services'
import { ModalController, ToastController } from '@ionic/angular';

@Component({
  selector: 'smr-sale-refund-interac',
  templateUrl: './sale-refund-interac.component.html',
  styleUrls: ['./sale-refund-interac.component.scss'],
})
export class SaleRefundInteracComponent  implements OnInit {

  @Input() sale;
  @Input() cardInfo;
  reader;
  public connectPushed: boolean;
  readerConnected  

  public cardReaderConnectError: boolean;

  public foundReaders: boolean;

  public refundError: boolean = false;
  public refundProcessing: boolean = true;

  public readerConnectSuccessful: boolean;

  constructor(
    private stripeService: StripeService,
    private userService: UserService,
    private modalCtrl: ModalController,
    private toastCtrl: ToastController,
    private ref: ChangeDetectorRef,
  ) { }

  async ngOnInit() {
    const res = await this.stripeService.discoverReaders();
    if(JSON.parse(localStorage.getItem('cardReader'))){
      this.reader = JSON.parse(localStorage.getItem('cardReader'))
    } else {
      if(res.discoveredReaders){
        this.reader = res.discoveredReaders[0];
        localStorage.setItem('cardReader', JSON.stringify(this.reader))
      }
    }
    const readerConnection = await this.stripeService.getStatus(this.reader);
    this.readerConnected = readerConnection === 'connected';
    this.foundReaders = !(
      res.code === 'reader_not_found' || res.code === 'reader_error'
    );
    if(!this.readerConnected) {
      const connectResponse = await this.stripeService.connectReader(JSON.parse(localStorage.getItem('cardReader')));
      if (connectResponse['error']) {
      } else {
        this.readerConnected = true;
      }
  }
    this.ref.detectChanges();
    if (this.readerConnected) {
      this.terminalRefund(this.reader );
    }
  }

  public async connectCardReader() {
    this.connectPushed = true;
    this.cardReaderConnectError = false;
    const connectResponse = await this.stripeService.connectReader(this.reader);
    if (connectResponse['error']) {
      this.cardReaderConnectError = true;
      this.connectPushed = false;
    } else {
      this.readerConnectSuccessful = true;
      this.readerConnected = true;
      this.ref.detectChanges();
      await this.terminalRefund(this.reader);
    }
  }

  public async terminalRefund(reader) {
    const refund = await this.stripeService.refundDebit(reader, {
      paymentChargeID: this.cardInfo.chargeID,
      amount:  (0-this.sale.total)*100,
      currency: this.userService.getSalon().getCountry().countryName === 'Canada' ? 'cad' : 'usd'
    })

    if(refund.error) {
      this.refundError = true;
      return;
    } else {
      this.modalCtrl.dismiss(true)
    }
  }
  onDismiss() {
    this.modalCtrl.dismiss(false);
  }

  retry() {
    this.refundError = false;
    this.terminalRefund(this.reader);
  }
}
